import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ChangeDetectorRef,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxIconComponent } from '../../rx-icon/rx-icon.component';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'rx-list-video-item',
  templateUrl: './rx-list-video-item.component.html',
  styleUrls: ['./rx-list-video-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    MatIconModule,
    RxIconComponent,
    FormsModule,
    MatCheckboxModule,
    MatMenuModule,
    MatListModule,
  ],
})
export class RxListVideoItemComponent implements OnInit, OnDestroy {
  @Input()
  public enableDrag: boolean;

  @Output()
  public enableDragChange = new EventEmitter<boolean>();

  @Input()
  public hasCheckbox = true;

  @Input()
  public description;

  @Input()
  public video: string;

  @Input()
  public showMenuHandle = true;

  @Input()
  public showDragHandle: boolean;

  @Input()
  public actionMenu: any;

  @Input()
  public actionMenuContext: any;

  @Input()
  public width = 120;

  @Input()
  public height = 120;

  @Input()
  public disableMenu = false;

  @Input()
  public disableCheckbox = false;

  // Checked two way binding
  @Output()
  public checkedChange = new EventEmitter<boolean>();

  @Output()
  public clickedCheckbox = new EventEmitter<any>();

  @Output()
  public showPreview = new EventEmitter<any>();

  @Input()
  public set checked(val) {
    if (this._checked === !!val) {
      return;
    }
    this._checked = !!val;
    this._cd.detectChanges();
  }

  public get checked() {
    return this._checked;
  }

  protected _checked = false;

  constructor(private _cd: ChangeDetectorRef) {}

  public ngOnInit() {}

  public ngOnDestroy() {}

  public checkedChanged(event) {
    this.checkedChange.emit(event.checked);
  }

  public clickCheckbox(event) {
    this.clickedCheckbox.emit(event);
  }

  public onMenuClicked($event) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  public onEnableDrag(state: boolean) {
    if (this.enableDrag !== state) {
      this.enableDrag = state;
      this.enableDragChange.emit(state);
    }
  }

  public onShowPreview() {
    this.showPreview.emit();
  }
}
